"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Loader = exports.BORDER_CLASSNAME = exports.SIZE_CLASSNAMES = void 0;
var react_1 = __importDefault(require("react"));
var common_1 = require("../../constants/common");
var BORDER_COLOR_CLASSNAMES = {
    blue: 'tw-border-t-blue-500',
    white: 'tw-border-t-white',
    black: 'tw-border-t-black',
};
exports.SIZE_CLASSNAMES = (_a = {},
    _a[common_1.SIZE_TYPES.XSMALL] = 'tw-w-3 tw-h-3',
    _a[common_1.SIZE_TYPES.SMALL] = 'tw-w-6 tw-h-6',
    _a[common_1.SIZE_TYPES.MEDIUM] = 'tw-w-8 tw-h-8',
    _a[common_1.SIZE_TYPES.LARGE] = 'tw-w-12 tw-h-12',
    _a[common_1.SIZE_TYPES.XLARGE] = 'tw-w-16 tw-h-16',
    _a);
exports.BORDER_CLASSNAME = (_b = {},
    _b[common_1.SIZE_TYPES.XSMALL] = 'tw-border-[2px]',
    _b[common_1.SIZE_TYPES.SMALL] = 'tw-border-[3px]',
    _b[common_1.SIZE_TYPES.MEDIUM] = 'tw-border-[4px]',
    _b[common_1.SIZE_TYPES.LARGE] = 'tw-border-[5px]',
    _b[common_1.SIZE_TYPES.XLARGE] = 'tw-border-[6px]',
    _b);
var elemClassName = 'tw-absolute tw-inset-0 tw-w-full tw-h-full tw-border-transparent tw-rounded-full';
var Loader = function (_a) {
    var _b = _a.size, size = _b === void 0 ? common_1.SIZE_TYPES.MEDIUM : _b, _c = _a.color, color = _c === void 0 ? 'blue' : _c;
    return (react_1.default.createElement("div", { className: "loader tw-relative " + exports.SIZE_CLASSNAMES[size] },
        react_1.default.createElement("div", { className: elemClassName + " " + exports.BORDER_CLASSNAME[size] + " tw-border-[#5d6069]" }),
        react_1.default.createElement("div", { className: "loader-elem-1 " + elemClassName + " " + exports.BORDER_CLASSNAME[size] + " " + BORDER_COLOR_CLASSNAMES[color] }),
        react_1.default.createElement("div", { className: "loader-elem-2 " + elemClassName + " " + exports.BORDER_CLASSNAME[size] + " " + BORDER_COLOR_CLASSNAMES[color] }),
        react_1.default.createElement("div", { className: "loader-elem-3 " + elemClassName + " " + exports.BORDER_CLASSNAME[size] + " " + BORDER_COLOR_CLASSNAMES[color] }),
        react_1.default.createElement("div", { className: "loader-elem-4 " + elemClassName + " " + exports.BORDER_CLASSNAME[size] + " " + BORDER_COLOR_CLASSNAMES[color] })));
};
exports.Loader = Loader;
